/**
 * @typedef {Object}            Review
 * @property {String}           author_name
 * @property {Number}           rating
 * @property {String}           text - Review content
 * @property {Number}           time - Review timestamp
 * @property {String}           relative_time_description
 */

const plural = (number) => {
  if (number !== 1) return 's';
  return '';
};

/**
 * @param {Date} date
 * @returns {String}
 */
function getRelativeTime(date) {
  const now = new Date();
  const diffMs = now - date;
  const seconds = Math.floor(diffMs / 1000);
  const minutes = Math.floor(diffMs / (1000 * 60));
  const hours = Math.floor(diffMs / (1000 * 60 * 60));
  const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  const weeks = Math.floor(days / 7);
  const months = Math.floor(days / 30.44); // Average days in a month
  const years = Math.floor(days / 365.25); // Average days in a year

  if (seconds < 60) return 'just now';
  if (minutes < 60) return `${minutes} minute${plural(minutes)} ago`;
  if (hours < 24) return `${hours} hour${plural(hours)} ago`;
  if (days < 7) return `${days} day${plural(days)} ago`;
  if (weeks < 5) return `${weeks} week${plural(weeks)} ago`;
  if (months < 12) return `${months} month${plural(months)} ago`;
  return `${years} ${plural(years)} ago`;
}

/**
 * @type {[Review]}
 */
export default [
  {
    author_name: 'Emily Dones',
    rating: 5,
    text: `
      Clareza Skin is a hidden gem that I’m so glad I found! Sarah provided exceptional love and care 
      during my facial and has a toolkit of gadgets to enhance the service. 
      However, nothing compares to her magical fingers and the incredible facial massage - 
      the extra time she spent on my jaw had all my tension literally melting away. 
      Sarah is extremely knowledgeable and suggested additions to my at home skincare routine that didn’t break the bank. 
      She provides services not typically found at your standard spa which makes Clareza Skin even more special. 
      Sarah is someone I could chat with all day, but once you’re under her treatment you’re transported to another dimension of facial bliss! 
      I can’t wait for my next appointment!
    `,
    time: new Date(2024, 10, 15),
  },
  {
    author_name: 'Michelle Bryant',
    rating: 5,
    text: `
      Sarah did a hair treatment/spa on me today and it was wonderful. 
      She took me thru the steps painlessly and really made the experience memorable. 
      Seeing my scalp under microscope was very interesting, nice to see the before & after this way. My hair/scalp feels fresh and rejuvenated. 
      Would definitely suggest this to anyone who deals with thinning hair or just needs a "revamp". Will be booking again with Sarah!
    `,
    time: new Date(2024, 10, 15),
  },
  {
    author_name: 'Jenna Demaya',
    rating: 5,
    text: `
      Amazing first visit. My scalp treatment was heavenly. The right combination of informative and relaxing. 
      Sarah is such a bubbly and friendly person. She walks you through each step and makes sure you’re comfortable the entire time. 
      You rarely see this type of treatment offered in this area. I would highly recommend Sarah and any of her products. 
      I went with a 90 minute scalp treatment that was super affordable. 
      I got my own comfy robe, great smelling weighted warming eye covers and relaxing music to unwind too. 
      My hair feels so clean and light! I even picked up a bottle of her own self made hair oil to use at home. If you have the time, check her out.
    `,
    time: new Date(2024, 10, 15),
  },
  {
    author_name: 'Sami Jarrar',
    rating: 5,
    text: `
      My wife had a wonderful experience with Sarah from start to finish. 
      She keeps telling me how healthy her scalp and hair feels since after her treatment with Sarah. Thank you for making her smile!
    `,
    time: new Date(2024, 8, 15),
  },
].map(r => ({
  ...r,
  relative_time_description: getRelativeTime(r.time),
}));
